import Vue from "vue";
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import es from 'vee-validate/dist/locale/es.json';
import { required, email,alpha_spaces,numeric } from 'vee-validate/dist/rules';


// Add a rule.
extend('email', {
    ...email,
    message:"Introduzca una dirección de correo electrónico válida."
});

extend('alpha_spaces', {
    ...alpha_spaces,
    message:"Este campo sólo acepta letras y espacios."
});

extend('numeric', {
    ...numeric,
    message:"Este campo sólo acepta números."
});

extend('max', {
    validate(value,args){
        return value.length <= args.length;
    },
    params:['length'],
    message:"Este campo acepta máximo {length} caracteres."
});

extend('min', {
    validate(value,args){
        return value.length >= args.length;
    },
    params:['length'],
    message:"Este campo acepta mínimo {length} caracteres."
});

extend('checked', {
    validate(value){
        return value;
    },
    message:"Acepta el aviso de privacidad para continuar."
});

// Override the default message.
extend('required', {
  ...required,
  message: 'Este campo es obligatorio.'
});

// Register it globally
Vue.component('ValidationProvider', ValidationProvider);